import React from 'react';
import PropTypes from 'prop-types';
import {
  Spacer,
  Label,
  Checkbox,
  Visible,
} from '@tfecom-thermofisher/react-komodo-design';

import { Message } from 'src/core/components';
import { POOLED_PLATES } from 'src/constants/forms';
import messages from '../../../messages';

const PooledPlates = ({
  showPooledPlates,
  showPooledscrollBar,
  checkedPooledPlates,
  pooledPlates,
  onCheckPlates
}) => (
  <div>
    <Label>
      <Message message={messages.pooledPlates} />
    </Label>
    <div className={`pooled-wrapper ${showPooledscrollBar ? '--show-scroll' : ''}`}>
      <Visible when={showPooledPlates}>
        {pooledPlates?.map((item, index) => (
          <div key={item.name}>
            <Checkbox
              onChange={() => onCheckPlates(index, POOLED_PLATES)}
              checked={checkedPooledPlates.includes(index)}
              inline
            >
              {item.name}
            </Checkbox>
            <Spacer bottom={10} />
          </div>
        ))}
      </Visible>
    </div>
  </div>
);

PooledPlates.propTypes = {
  showPooledPlates: PropTypes.bool.isRequired,
  showPooledscrollBar: PropTypes.bool.isRequired,
  checkedPooledPlates: PropTypes.array.isRequired,
  pooledPlates: PropTypes.array.isRequired,
  onCheckPlates: PropTypes.func.isRequired
};

export default PooledPlates;
